import React, { useEffect, useState } from 'react'
import api from '../../api/axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Topbar from '../layout/Topbar';
import { useBookStore } from '../../provider/BookStore';
import { getErrorMessage, logError } from '../../utils/errorHandler';

const AddBook = () => {
    const [title, setTitle] = useState('');
    const [msg, setMsg] = useState('');
    const navigate = useNavigate();
    
    const bookState = useBookStore();
    const book = bookState.book;

    const location = useLocation();
    const action = location.state?.action;

    useEffect(() => {
        if(action === 'edit'){
            setTitle(book.title)
        }
    }, []);

    const createBook = async (e) => {
        e.preventDefault();

        if (book.id === undefined) {
            navigate('/')
        }

        if(action === 'edit'){
            try {
                await api.post('/book/save',{
                    book_id: book.id,
                    title: title,
                    display: book.display,
                    weekly_start: book.weekly_start,
                    monthly_start: book.monthly_start,
                    yearly_start: book.yearly_start,
                    custom_start: book.custom_start,
                    custom_end: book.custom_end
                })
                navigate('/')
            } catch (error) {
                logError('Gagal menyimpan buku kas:', error);
                setMsg(getErrorMessage(error, 'Gagal menyimpan buku kas.'));
            }
        }else{
            try {
                const response = await api.post('/book/add', {
                    title: title
                });
                console.log(response.data)
                navigate("/", { replace: true })
            } catch (error) {
                logError('Gagal menambah buku kas:', error);
                setMsg(getErrorMessage(error, 'Gagal menambah buku kas.'));
            }
        }
    }

    return (
        <div>
            <Topbar
                title={action === 'edit' ? 'Edit Buku Kas' : 'Tambah Buku Kas'}
                back={()=>navigate(-1)}
            />
            <div className="container p-5">
                <div className="columns is-centered">
                    <div className="column is-5-widescreen is-6-desktop is-7-tablet">
                        <form onSubmit={createBook} className="card">
                            <div className='card-content'>
                                <p className="has-text-centered">{msg}</p>
                                <div className="field mt-5">
                                    <label className="label">Nama Buku Kas</label>
                                    <div className="controls">
                                        <input type="text" className="input" placeholder='Nama Buku'
                                            value={title} onChange={(e) => setTitle(e.target.value)} />
                                    </div>
                                </div>

                            </div>
                            <footer className="card-footer  has-text-white has-background-primary-30">
                                <button className="card-footer-item has-text-weight-bold ">Simpan</button>
                            </footer>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddBook
